<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="maxWidth"
    :min-width="minWidth"
  >
    <template v-if="showActivator" v-slot:activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs">
        <div class="d-flex justify-center align-center">
          <v-icon
            :color="iconColor"
            :size="iconSize"
            v-bind="attrs"
            v-on="on"
          >
            {{ icon }}
          </v-icon>
        </div>
      </slot>
    </template>
    <v-card class="pa-4">
      <div class="d-flex flex-column">
        <div v-if="showCloseIcon" class="d-flex justify-end">
          <v-icon @click.stop="dialog = false" class="ma-2">
            close
          </v-icon>
        </div>
        <h2 class="text-h6">
          {{ title }}
        </h2>
        <slot />
        <div class="d-flex justify-end flex-grow-1 mt-4">
          <v-btn
            class="mr-2"
            text
            small
            elevation="0"
            color="red"
            @click="cancelClick()"
          >
            {{ cancelBtnLabel }}
          </v-btn>
          <v-btn
            elevation="0"
            small
            color="primary"
            @click="confirmClick()"
          >
            {{ confirmBtnLabel }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    showActivator: {
      type: Boolean,
      default: false,
    },
    showCloseIcon: {
      type: Boolean,
      default: false,
    },
    confirmBtnLabel: {
      type: String,
      default: 'Ok',
    },
    cancelBtnLabel: {
      type: String,
      default: 'Cancel',
    },
    title: {
      type: String,
      default: 'Confirmation Dialog Title',
    },
    opened: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'add',
    },
    iconSize: {
      type: String,
      default: undefined,
    },
    iconColor: {
      type: String,
      default: 'grey',
    },
    maxWidth: {
      type: String,
      default: '700px',
    },
    minWidth: {
      type: String,
      default: '400px',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    confirmClick() {
      this.$emit('confirm');
      this.close();
    },
    cancelClick() {
      this.$emit('cancel');
      this.close();
    },
    close() {
      this.dialog = false;
    },
    open() {
      this.dialog = true;
    },
  },
  watch: {
    opened() {
      this.dialog = this.opened;
    },
  },
};
</script>
